import { render, staticRenderFns } from "./mainParentCard.vue?vue&type=template&id=08e27ef2&scoped=true&"
import script from "./mainParentCard.vue?vue&type=script&lang=js&"
export * from "./mainParentCard.vue?vue&type=script&lang=js&"
import style0 from "./mainParentCard.vue?vue&type=style&index=0&id=08e27ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e27ef2",
  null
  
)

export default component.exports